// @flow
import React from "react";
import styled from "styled-components";
import { TextInput } from "@nested/ui";
import Menu from "./Menu";

type Props = {
  name: string,
  value: Address | null,
  onChange(
    value: AddressPickerPostcodeDetails_postcodeDetails_addresses, // eslint-disable-line
  ): void,
  placeholder?: string,
  label?: string,
  debounceTimeout?: number,
  includeBlacklisted?: boolean,
  onPostcodeNotInServicedArea?: any,
  highContrast?: boolean,
};

type State = {
  postcode: string,
  menuOpen: boolean,
};

const Wrapper = styled.div`
  position: relative;
`;

export class AddressPicker extends React.Component<Props, State> {
  state = {
    postcode: "",
    menuOpen: false,
  };

  updatePostcode = (e: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      postcode: e.target.value,
    });
  };

  onFocus = () => {
    this.setState({ menuOpen: true });
  };

  selectAddress = (
    address: AddressPickerPostcodeDetails_postcodeDetails_addresses, // eslint-disable-line
  ) => {
    const { onChange } = this.props;
    onChange(address);
    this.setState({
      menuOpen: false,
    });
  };

  render() {
    const {
      name,
      placeholder,
      value,
      highContrast,
      label,
      debounceTimeout,
      includeBlacklisted,
      onPostcodeNotInServicedArea,
    } = this.props;
    const { postcode, menuOpen } = this.state;

    return (
      <Wrapper>
        <TextInput
          highContrast={highContrast}
          label={label}
          data-test="address-picker-postcode"
          value={
            !menuOpen && value ? `${value.label}, ${value.postcode}` : postcode
          }
          onChange={this.updatePostcode}
          name={name}
          placeholder={placeholder}
          onFocus={this.onFocus}
          autoComplete="this-prevents-autocomplete-off-doesnt-work"
        />
        {menuOpen && (
          <Menu
            highContrast={highContrast}
            debounceTimeout={debounceTimeout}
            onChange={this.selectAddress}
            value={value}
            postcode={postcode}
            includeBlacklisted={includeBlacklisted}
            onPostcodeNotInServicedArea={onPostcodeNotInServicedArea}
          />
        )}
      </Wrapper>
    );
  }
}
